import { bindActionCreators as bind } from 'redux';
import { clearSubmissionAttachments } from '../../../actions/attachmentActions';
import { hideModal, showModal } from '../../../actions/modalActions';
import * as submissionInfoActions from '../../../actions/submissionInfoActions';
import { actions } from 'react-redux-form';

export const sharedDispatchToProps = (dispatch) => {
  return {
    clearSubmissionAttachments: bind(clearSubmissionAttachments, dispatch),
    hideModal: bind(hideModal, dispatch),
    resetForm: bind(actions.reset, dispatch),
    showModal: bind(showModal, dispatch),
    submissionInfoActions: bind(submissionInfoActions, dispatch)
  };
};

export const sharedStateToProps = (state) => {
  const { email } = (state.contacts && state.contacts.account_manager) || {};
  const { id } = state.submissionInfo.submission.info || {};
  return {
    accountManagerEmail: email,
    failedUploads: state.attachments.failed,
    leadId: id,
    step: state.submissionInfo.form.section,
    submission: state.submission,
    submissionInfo: state.submissionInfo
  };
};
